import {
  Zap,
  Bot,
  Calendar,
  ChartLine,
  Database,
  Files,
  House,
  Route,
  Search,
  Settings,
  FileText,
  Shield,
  Shapes,
  Sparkles,
} from "lucide-react";

import type { FeatureFlagName } from "@/shared/domain/featureFlags/FeatureFlagName";
import { Env } from "@/shared/environment";
import { Goto } from "@/shared/navigation/Goto";

export interface NavGroups {
  features: NavLink[];
  actionsAndAgents: NavLink[];
  settingsAndGuides: NavLink[];
  admin: NavLink[];
}

export interface NavLink {
  name: string;
  link: string;
  icon: React.ElementType;
  isExternalLink?: boolean;
  /**
   * Render this link only when the named flag is on for the current org.
   * Hidden while loading or on fetch failure (fail-closed).
   */
  featureFlag?: FeatureFlagName;
  /**
   * Render this link only when the named flag is OFF for the current org.
   * Shown while loading or on fetch failure, mirroring `featureFlag`'s
   * fail-closed treatment of an unresolved flag as off.
   */
  hideWhenFeatureFlag?: FeatureFlagName;
}

export const navGroups: NavGroups = {
  features: [
    {
      name: "Home",
      link: Goto.route.Home,
      icon: House,
    },
    {
      name: "Search",
      link: Goto.route.Search,
      icon: Search,
      hideWhenFeatureFlag: "release-feature-pages",
    },
    {
      name: "Datasets",
      link: Goto.route.Datasets,
      icon: Database,
      featureFlag: "release-feature-pages",
    },
    {
      name: "Files",
      link: Goto.route.Files,
      icon: Files,
      featureFlag: "release-feature-pages",
    },
    {
      name: "Events",
      link: Goto.route.Events,
      icon: Calendar,
      featureFlag: "release-feature-pages",
    },
    {
      name: "Collections",
      link: Goto.route.Collections,
      icon: Shapes,
    },
    {
      name: "Devices",
      link: Goto.route.Devices,
      icon: Bot,
    },
    {
      name: "Sessions",
      link: Goto.route.Sessions,
      icon: Route,
      featureFlag: "release-sessions",
    },
    {
      name: "Metrics",
      link: "/metrics",
      icon: ChartLine,
      featureFlag: "release-metrics",
    },
  ],
  actionsAndAgents: [
    {
      name: "Actions",
      link: "/actions",
      icon: Zap,
    },
    {
      name: "Agents",
      link: Goto.route.Agents,
      icon: Sparkles,
    },
  ],
  settingsAndGuides: [
    {
      name: "Settings",
      link: Goto.route.Settings.Root,
      icon: Settings,
    },
    {
      name: "Docs",
      isExternalLink: true,
      link: `https://${Env.docsDomain}`,
      icon: FileText,
    },
  ],
  admin: [
    {
      name: "Admin",
      link: Goto.route.Admin,
      icon: Shield,
    },
  ],
};
